import stringDateToJsonDate from '../../Utils/stringDataToJsonDate';

/* eslint-disable */
const formatCPProposal = (fields, saveAndApproval = false) => {
  const ID = parseInt(fields.propostaId || null, 10);

  const formatedFields = {
    Id: ID,
    HomeAccountId: fields.homeAccountId,
    SellerId: (fields.colaborador.vendedor?.value || fields.colaborador.vendedor) || null,
    Capture: (fields.colaborador.fonte?.value || fields.colaborador.fonteData?.value) || null,
    CoordinatorId: (fields.colaborador.coordenador?.value || fields.colaborador.coordenador) || null,
    Code: fields.colaborador.codProposta || null,
    ContrateSap: fields.SAPCode || fields.ContrateSap || "",
    ProposalTypeId: (fields.colaborador.tipoProposta?.value || fields.colaborador.tipoPropostaData?.id) || null,
    PriceLinkPayment: (saveAndApproval) ? (fields.paymentValue || 0) : 0,
    SystemBalance: fields.systemBalance || 0,
    ObservationNFE: fields.observacoes || null,
    UserName: fields.user?.displayName,
    UserEmail: fields.user?.mail,
    UserHomeAccountId: fields.accountInfo?.homeAccountId,
    ApprovalHierarchyId: fields.alcadaId,
    ProposalBombs: formatCPPBomb(fields, ID),
    ProposalTraits: formatCPPTrait(fields, ID),
    ProposalEstimate: {
      AffiliateId: (fields.filialCidade.filial?.value || fields.filialCidade.filial),
      CityId: (fields.filialCidade.cidade?.value || fields.filialCidade.city?.id || fields.filialCidade.cidade) || null,
      ProposalId: fields.filialCidade.id && ID ? ID : null,
      Distance: fields?.distancia ? fields.distancia.toString() : '',
      AdditionalInformation: fields?.filialCidade?.informacaoAdicional,
      Id: ID ? fields.filialCidade.id : null,
    },
    ProposalInvoicing: {
      ContractType: (fields.faturamento.tipoContrato?.value ?? fields.faturamento.tipoContrato) || null,
      CustomerType: fields.emissor.pessoa?.value || null,
      Email: fields.faturamento.email,
      Emails: fields.faturamento.emails.length ? fields.faturamento.emails.join(',') : null,
      Nome: fields.faturamento.nome || null,
      Phone: fields.faturamento.telFixo || null,
      CelPhone: fields.faturamento.telCelular || null,
      CEP: fields.faturamento.cep || null,
      Address: fields.faturamento.endereco || null,
      NumberAddress: fields.faturamento.numero || null,
      Neighborhood: fields.faturamento.bairro || null,
      City: fields.faturamento.cidade || null,
      UF: fields.faturamento.uf?.value || null,
      Complement: fields.faturamento.complemento || null,
      CreditLimit: fields.faturamento.limiteCredito || null,
      CEI_CNO: fields.faturamento.cei || null,
      CEI_CNOHave: fields.faturamento.possuiCei || null,
      SFOBRAS: fields.faturamento.sfobras || null,
      SFOBRASHave: fields.faturamento.possuiSfobras || null,
      PaymentId: (fields.faturamento.pagamento?.value || fields.faturamento.pagamento) || null,
      ProposalId: ID,
      Payment: fields.faturamento.payment || null,
      CenterCost: (fields.faturamento.tipoContrato === 3 || fields.faturamento.tipoContrato?.value === 3)
        ? (fields.faturamento.centerCost || null)
        : null,
      ElementPEP: (fields.faturamento.tipoContrato === 3 || fields.faturamento.tipoContrato?.value === 3)
        ? (fields.faturamento.elementPEP || null)
        : null,
      Id: ID ? fields.faturamento.id : null,
    },
    ProposalIssuer: {
      Code: fields.emissor.codEmissor || null,
      CustomerType: fields.emissor.pessoa?.value || null,
      CPF_CNPJ: fields.emissor.cpfCnpj || null,
      CorporateName: fields.emissor.razaoSocial || null,
      MunicipalRegistration: fields.emissor.inscricaoMunicipal || null,
      FoundationDate: fields.emissor.dataNascimento || null,
      SegmentId: fields.emissor.grupoSegmento?.value || null,
      ProposalId: ID,
      Id: ID ? fields.emissor.id : null,
    },
    ProposalReceiver: {
      CopiedFromInvoicing: fields.recebedor.copiadoDoFaturamento || false,
      Code: fields.recebedor.codigo?.value || null,
      Name: fields.recebedor.nome || null,
      Phone: fields.recebedor.telFixo || null,
      CelPhone: fields.recebedor.telCelular || null,
      Office: fields.recebedor.cargo || null,
      CEP: fields.recebedor.cep || null,
      Address: fields.recebedor.endereco || null,
      NumberAddress: fields.recebedor.numero || null,
      Neighborhood: fields.recebedor.bairro || null,
      City: fields.recebedor.cidade || null,
      UF: fields.recebedor.uf?.value || null,
      Complement: fields.recebedor.complemento || null,
      MunicipalRegistration: fields.recebedor.inscricaoMunicipal || null,
      ProposalId: ID,
      Id: ID ? fields.emissor.id : null,
    },
    ProposalMargin: {
      ProposalId: ID,
      FinalPrice: fields.margemAlcadas.margem.precoFinal,
      Tax: fields.margemAlcadas.margem.imposto,
      MCC: fields.margemAlcadas.margem.mcc,
      Margin: fields.margemAlcadas.margem.margem,
      FixedCostDelivery: fields.custosEntrega.CustoFixoTotal,
      CostDieselDelivery: fields.custosEntrega.CustoCombustivel,
      CostDieselPump: fields.margemAlcadas.margem.custoDieselPaBomba,
      PumpMargin: fields.margemAlcadas.margem.margemBomba,
      AdditionalMedia: fields.margemAlcadas.margem.adicionalMedia,
      MarginFree: fields.margemAlcadas.margem.margemLivre,
      MarginDRE: fields.margemAlcadas.margem.margemDRE,
      Id: ID ? fields.margemAlcadas.margem.id : null,
    },
    NegotiationDate: stringDateToJsonDate(fields.dataNegociacao.data)
  };
  if (fields.RazoesParaPerda.reasonForLoss !== "") {
    formatedFields.ProposalReasonForLoss = {
      PlayerId: fields.RazoesParaPerda.playerId,
      LossCauseId: fields.RazoesParaPerda.lossCauseId,
      ReasonForLoss: fields.RazoesParaPerda.reasonForLoss,
      Competitor: fields.RazoesParaPerda.competitor,
      Margin: fields.RazoesParaPerda.margin,
      WeightedTotal: fields.RazoesParaPerda.weightedTotal,
      TotalBudget: fields.RazoesParaPerda.totalBudget,
      DeadlineDays: fields.RazoesParaPerda.deadline,
      ProposalId: fields.propostaId || null
    }
  }

  return formatedFields;
};

export default formatCPProposal;

export const formatCPPBomb = (fields, ID) => {

  const proposalBombs = [...fields.bombas.selecionadas].map((bomb) => ({
    PriceNegotiated: bomb.valorTotal,
    Volume: bomb.volume,
    VolumeMinimum: bomb.volumeMinimoBomba,
    Discount: bomb.desconto || 0,
    PriceRule: bomb.taxaBombaRegra,
    MinPrice: bomb.taxaBombaMinima,
    Cost: bomb.custo,
    TurnDelivery: (bomb.turno?.value || bomb.turno) || 1,
    DateDelivery: bomb.dataEntrega ? bomb.dataEntrega.split('/').reverse().join('-') : null,
    ProposalId: ID,
    Inclusion: false,
    InclusionOrder: bomb.ordemInclusao,
    AffiliateBombId: bomb.bombaAfiliadoId,
    BombId: bomb.bombaId,
    BombName: bomb.bomba,
    OriginalApprovalSubmission: bomb.originalApprovalSubmission,
    OriginalCreatedAt: bomb.originalCreatedAt,
    Id: ID ? bomb.id : null,
  }));

  const proposalBombsInclusion = [...fields.inclusaoBombas.selecionadas].map((bomb) => ({
    PriceNegotiated: bomb.valorTotal,
    Volume: bomb.volume,
    VolumeMinimum: bomb.volumeMinimoBomba,
    Discount: 0,
    PriceRule: bomb.taxaBombaRegra,
    MinPrice: bomb.taxaBombaMinima,
    Cost: bomb.custo,
    TurnDelivery: (bomb.turno?.value || bomb.turno) || 1,
    DateDelivery: bomb.dataEntrega ? bomb.dataEntrega.split('/').reverse().join('-') : null,
    ProposalId: ID,
    Inclusion: true,
    InclusionOrder: bomb.ordemInclusao,
    AffiliateBombId: bomb.bombaAfiliadoId,
    BombId: bomb.bombaId,
    BombName: bomb.bomba,
    OriginalApprovalSubmission: bomb.originalApprovalSubmission,
    OriginalCreatedAt: bomb.originalCreatedAt,
    Id: ID ? bomb.id : null,
  }));

  return [...proposalBombs, ...proposalBombsInclusion];
}

export const formatCPPTrait = (fields, ID) => {
  const hasInclusions = hasInclusion(fields);

  const proposalTraits = [...fields.tracos.selecionados].map((traco) => ({
    AffiliateTraitId: traco.tracoAfiliadoId,
    PriceNegotiated: traco.precoNegociado,
    Volume: traco.volume,
    Discount: traco.desconto,
    PriceRule: traco.precoRegra,
    PriceRuleView: traco.precoRegraView,
    DiscountPriceRule: traco.descontoPrecoRegra,
    PriceFinal: (hasInclusions || (fields.SAPCode && !hasInclusions)) ? traco.precoFinalSalvo : traco.precoFinal,
    PriceRuleWithAdditional: precoRegraComAdicionalDoTraco(traco, hasInclusions, fields.SAPCode),
    PriceAdditional: precoRegraComAdicionalDoTraco(traco, hasInclusions, fields.SAPCode) - traco.precoRegra,
    PriceDistanceAdditional: adicionalDistanciaDoTraco(traco),
    Bomb: traco.bomba,
    ProposalId: ID,
    Margin: traco.margem,
    MCC: traco.mcc,
    Tax: traco.imposto,
    Inclusion: false,
    InclusionOrder: traco.ordemInclusao,
    TraitId: traco?.traitId,
    TraitName: traco?.traco,
    OriginalApprovalSubmission: traco.originalApprovalSubmission,
    OriginalCreatedAt: traco.originalCreatedAt,
    Id: ID ? traco.id : null,
  }));

  const proposalTraitsInclusion = [...fields.inclusaoTracos.selecionados].map((traco) => ({
    AffiliateTraitId: traco.tracoAfiliadoId,
    PriceNegotiated: traco.precoNegociado,
    Volume: traco.volume,
    Discount: traco.desconto,
    PriceRule: traco.precoRegra,
    PriceRuleView: traco.precoRegraView,
    DiscountPriceRule: traco.descontoPrecoRegra,
    PriceFinal: traco.precoFinal,
    PriceRuleWithAdditional: traco.precoRegraComAdicional,
    PriceAdditional: (traco.precoRegraComAdicional || traco.precoRegra) - traco.precoRegra,
    PriceDistanceAdditional: adicionalDistanciaDoTraco(traco),
    Bomb: traco.bomba,
    ProposalId: ID,
    Margin: traco.margem,
    MCC: traco.mcc,
    Inclusion: true,
    InclusionOrder: traco.ordemInclusao,
    TraitId: traco?.traitId,
    TraitName: traco?.traco,
    OriginalApprovalSubmission: traco.originalApprovalSubmission,
    OriginalCreatedAt: traco.originalCreatedAt,
    Id: ID ? traco.id : null,
  }));

  return [...proposalTraits, ...proposalTraitsInclusion];
}

const precoRegraComAdicionalDoTraco = (traco, hasInclusions, SAPCode) => ((hasInclusions || (SAPCode && !hasInclusions))
  ? (traco.precoRegraComAdicionalSalvo ?? traco.precoRegraComAdicional)
  : traco.precoRegraComAdicional);

const adicionalDistanciaDoTraco = (traco) => (
  traco.tracoAfiliado?.distanceAdditionalPrice ?? traco.adicionalDistanciaSalvo ?? null
);

const hasInclusion = (fields) => {
  return [
    ...fields.inclusaoTracos.selecionados,
    ...fields.inclusaoBombas.selecionadas,
  ].some((item) => !!item);
}